/*
 * @Descripttion: 
 * @version: 
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2019-10-21 18:20:16
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2020-09-10 11:01:06
 */
import md5 from 'js-md5';
const state = {
    baseInfo: {
        appName: 'WechatService',
        companyName: '微信服务平台',
        organizationName: '', //机构名称
        organizationNickName: '', //机构英文名称
    },
    isLogin: false,
    userID: null, //角色id
    fullPath:'',//授权成功后重定向路由
}

export default state


// WEBPACK FOOTER //
// ./src/store/state.js